export default __webpack_public_path__ + "static/media/mobile_medium_engaged.5cc15a91.svg";